import { createAsyncThunk } from '@reduxjs/toolkit';
import apiFetch from '@wordpress/api-fetch';
import { PLUGINS } from './constants';

export const fetchPlugins = createAsyncThunk(PLUGINS.FETCH_PLUGINS, async () => {
    const response = await apiFetch({
        method: 'GET',
        path: '/plugins',
    });
    return response.data;
});

export const fetchPlugin = createAsyncThunk(PLUGINS.FETCH_PLUGIN, async (id) => {
    const response = await apiFetch({
        method: 'GET',
        path: `/plugins/${id}`,
    });
    return response.data;
});

export const fetchPluginLicense  = createAsyncThunk(PLUGINS.FETCH_PLUGIN_LICENSE, async (id) => {
    const response = await apiFetch({
        method: 'GET',
        path: `/licenses/${id}`,
    });
    return response.data;
});

export const fetchDownloads  = createAsyncThunk(PLUGINS.FETCH_DOWNLOADS, async (licenseId) => {
    const response = await apiFetch({
        method: 'GET',
        path: `/downloads/${licenseId}`,
    });
    return response.data;
});

export const deletePluginDomain = createAsyncThunk(PLUGINS.DELETE_PLUGIN_DOMAIN, async ({licenseId, domainId}) => {
    const response = await apiFetch({
        method: 'DELETE',
        path: `/licenses/${licenseId}/domains/${domainId}`,
    });
    return response.data;
});
